import { useParams } from "react-router";

export const useApplicationId = () => {
	const { applicationId } = useParams();
	if (!applicationId) throw new Error("no application id");
	return applicationId;
};
